import { render, staticRenderFns } from "./prod-card.vue?vue&type=template&id=3e8f277e&scoped=true"
import script from "./prod-card.vue?vue&type=script&lang=js"
export * from "./prod-card.vue?vue&type=script&lang=js"
import style0 from "./prod-card.vue?vue&type=style&index=0&id=3e8f277e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8f277e",
  null
  
)

export default component.exports